import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";
import QuizTicketListContainer from "@jumbo/Dashboards/Tests/QuizTicketList";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import { Box, Button } from "@material-ui/core";
import { baseUrl } from "@jumbo/constants/baseUrl";
import axios from "../../../services/auth/jwt/config";
import { useParams } from "react-router";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.testsPage"} />, link: "/tests" },
  { label: <IntlMessages id={"pages.quizTickets"} />, isActive: true },
];

const QuizTicketList = () => {
  const { id } = useParams();

  const handleDownload = async () => {
    const fileUrl = `${baseUrl}quizTicket/getAllByQuizIdFile/${id}`;
    try {
      const response = await axios.get(fileUrl, {
        responseType: "blob", 
      });

      const contentDisposition = response.headers["content-disposition"];
      let filename = "Participants.xlsx"; 

      if (contentDisposition) {
        const utf8FilenameRegex = /filename\*=UTF-8''([^;]+)/;
        const utf8Matches = utf8FilenameRegex.exec(contentDisposition);

        if (utf8Matches && utf8Matches[1]) {
          filename = decodeURIComponent(utf8Matches[1]);
        } else {
          const regularFilenameRegex = /filename="([^"]+)"/;
          const regularMatches = regularFilenameRegex.exec(contentDisposition);

          if (regularMatches && regularMatches[1]) {
            filename = regularMatches[1];
          }
        }
      }

      console.log("Decoded filename:", filename);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename); 
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const handleDownloadAnswers = async () => {
    const fileUrl = `${baseUrl}quizanswer/getall/file/${id}`;
    try {
      const response = await axios.get(fileUrl, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      const contentDisposition = response.headers["content-disposition"];
      let filename = "Participants.xlsx";

      if (contentDisposition) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDisposition);
        if (matches && matches[1]) {
          filename = decodeURIComponent(matches[1].replace(/['"]/g, ""));
        }
      }

      link.download = filename;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <PageContainer
      heading={<IntlMessages id="pages.quizTickets" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Box
            marginBottom={"10px"}
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <IntlMessages id="pages.quizTickets.description" />
            <Box>
              <Button
                variant="contained"
                color="primary"
                startIcon={<ArrowDownwardIcon />}
                onClick={handleDownload}
                style={{ marginLeft: "10px" }}
              >
                فایل گزارش
              </Button>
              <Button
                variant="contained"
                color="primary"
                startIcon={<ArrowDownwardIcon />}
                onClick={handleDownloadAnswers}
              >
                پاسخ کاربران
              </Button>
            </Box>
          </Box>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <QuizTicketListContainer />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default QuizTicketList;
